import { IAggregator, IConfiguredAddon } from 'src/types/aggregator.types';
import { IInstanceConfiguration } from 'src/types/menu.types';

// The enhanced bundle flag isn't tied to a specific channel name - it's surfaced
// for whichever configured instance declares support via `settings.is_enhanced_configurable`.
export const getEnhancedBundleInstance = (aggregators?: IAggregator[]): IConfiguredAddon | undefined =>
  aggregators
    ?.flatMap((aggregator) => aggregator.configuredAddons)
    .find((addon) => addon.settings?.is_enhanced_configurable === true);

export const isEnhancedBundleFlagged = (
  instanceConfiguration: IInstanceConfiguration[] | undefined,
  instanceId: string | undefined,
): boolean =>
  instanceConfiguration?.find((config) => config.extension_instance_id === instanceId)?.config?.is_enhanced ?? false;
